// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__29SgN","dragIcon":"SortableItem_dragIcon__1BOtR","disabled":"SortableItem_disabled__2VfdG"};